// extracted by mini-css-extract-plugin
module.exports = {"amazon-sale-A":"A_amazon-sale-A__M5jYm"};